import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import BarsComponent from "./BarsComponent";

import { colors4 } from "../../../../constants/icons/characteristics/Characteristics";
import { CUADRADO } from "../../../../constants/icons/characteristics/Characteristics";

class CleanBarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      range: 0,
      characteristic: 0,
      colors: colors4,
      dataKey: "value",
      lineKey: "medVal",
      title: props.title,
    };
  }

  getPercentege = (val) => {
    const { data } = this.props;
    let sum = data.reduce((a, b) => ({ value: a.value + b.value })).value;
    return parseInt((val / sum) * 100) + "%";
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        range: 0,
        characteristic: 0,
      });
    }
  }

  getTotal = () => this.props.data.reduce((pre, cur) => pre + cur.value, 0);

  render() {
    return (
      <Grid style={{ flexWrap: "inherit", width: "100%" }} id={this.props.name}>
        <Grid
          container
          style={{ textAlign: "center", marginTop: "30px", marginBottom: "10px" }}
        >
          <Grid item xs={12}>
            <h2
              className="text-center client-label-second-color inline-block margin-left-20px"
              style={{ fontSize: "20px" }}
            >
              {this.props.title}
            </h2>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} style={{ height: "120px" }}>
            {
              <BarsComponent
                data={this.state.data}
                name={this.props.name}
                colors={this.state.colors}
                total={this.getTotal()}
                dataKey={this.state.dataKey}
                lineKey={this.state.lineKey}
              />
            }
          </Grid>
          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} style={{textAlign: 'left'}}>
              {this.props.data.map((entry, index) => (
                <div
                  className="legend-box-inform"
                  key={"item-pie-" + this.props.name + index}
                >
                  <div>
                    <svg
                      fill={this.state.colors[index % this.state.colors.length]}
                      height="8"
                      width="8"
                    >
                      {CUADRADO(this.state.colors[index % this.state.colors.length])}
                    </svg>
                  </div>
                  <p>
                    {entry.name +
                      " - " +
                      entry.value +
                      " - " +
                      this.getPercentege(entry.value)}
                  </p>
                </div>
              ))}
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default CleanBarComponent;
